import { render } from "./InstitucionalView.vue?vue&type=template&id=7d2710c0&scoped=true"
import script from "./InstitucionalView.vue?vue&type=script&lang=js"
export * from "./InstitucionalView.vue?vue&type=script&lang=js"

import "./InstitucionalView.vue?vue&type=style&index=0&id=7d2710c0&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2710c0"]])

export default __exports__